import { API_URL, MEDIA_URL, SITE_PUBLIC_DOMAIN } from '@/config'

const config = {
  API_URL: API_URL,
  MEDIA_URL: MEDIA_URL,
  SITE_PUBLIC_DOMAIN: SITE_PUBLIC_DOMAIN,
  VERSION: process.env.VUE_APP_VERSION
}

export default {
  install(Vue) {
    Vue.prototype.$config = config
  }
}